import { Loader2 } from "lucide-react";

export function Loader({ text }: { text: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-2">
      <Loader2 className="size-5 animate-spin text-muted-foreground" />
      <span className="text-muted-foreground">{text}</span>
    </div>
  );
}
